import { Pipe, PipeTransform } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';

@Pipe({
  name: 'spTimeFormat',
})
export class SpTimeFormatPipe implements PipeTransform {
  transform(input?: AnyType) {
    if (input) {
      const secs = parseInt(input, 10);
      if (isNaN(secs)) {
        return '--'
      }

      if (secs === 0) {
        return '00:00:00';
      }

      const hours = Math.floor(secs / (60 * 60));
      const minutes_modulus = secs % (60 * 60);
      const minutes = Math.floor(minutes_modulus / 60);
      const seconds_modulus = minutes_modulus % 60;
      const seconds = Math.ceil(seconds_modulus);
      return (
        (hours > 9 ? hours : '0' + hours) +
        ':' +
        (minutes > 9 ? minutes : '0' + minutes) +
        ':' +
        (seconds > 9 ? seconds : '0' + seconds)
      );
    }
    return '--';
  }
}
